<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteComercial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoGerentesComerciais" }'
    )
    .detalhes-gerente-comercial
        h3.detalhes-gerente-comercial__titulo {{ $t('mensagens.gerenteComercial.labels.dadosCadastrais') }}
        .detalhes-gerente-comercial__card
            Resume(resumeId='detalhes-gerente-comercial', :resume='resumeList')
        h3.detalhes-gerente-comercial__titulo(v-if='isBunge') {{ $t('mensagens.gerenteComercial.labels.dadosVinculados') }}
        .detalhes-gerente-comercial__card(v-if='isBunge')
            ResumeList(
                resumeId='detalhes-gerente-comercial',
                :label='$t("mensagens.gerenteComercial.keys.idsGerentesTerritoriais")',
                :resume='idsGerentesTerritoriais'
            )
        .footer
            .footer__btn.voltar(@click='irParaGerentesComerciais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';
import { mapGetters } from 'vuex';

export default {
    name: 'DetalhesGerenteComercial',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume'),
        ResumeList: () =>
            import('@/components/contratosOriginacao/formulario/ResumeList')
    },
    props: {
        resume: {
            type: [Array, Object],
            default: () => []
        }
    },
    data() {
        return {
            dados: {},
            idsGerentesTerritoriais: [],
            gerentesTerritoriais: [],
            gerentesRegionais: []
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        isBunge() {
            return this.usuarioLogado.isBunge;
        },
        resumeList() {
            const keysValids = ['idBunge', 'nome'];
            if (this.isBunge) {
                keysValids.push('idGerenteRegional');
            }
            const keyMap = keysValids.map(key => ({
                key,
                label: this.$t(`mensagens.gerenteComercial.keys.${key}`),
                value: this.dados?.[key] || '--'
            }));
            const resume = keyMap.sort(
                (a, b) => keysValids.indexOf(a.key) - keysValids.indexOf(b.key)
            );

            return resume;
        }
    },
    mounted() {
        this.carregarListasGerentes();
    },
    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            if (this.resume?.idsGerentesTerritoriais?.length > 0) {
                await this.buscarGerentesTerritoriais();
            }
            if (this.resume?.idGerenteRegional) {
                await this.buscarGerentesRegionais();
            }
            this.montarDados();
            this.loadingScreen(false);
        },
        montarDados() {
            const gerente = {
                nome: this.resume.nome,
                idBunge: this.resume.idBunge
            };
            const gerenteRegional = this.gerentesRegionais.find(
                gerente => this.resume?.idGerenteRegional === gerente?.id
            );

            gerente.idGerenteComercial = gerenteRegional?.nome || '--';

            if (this.resume?.idsGerentesTerritoriais?.length > 0) {
                const idsGerentesTerritoriais =
                    this.gerentesTerritoriais.filter(gerente =>
                        this.resume.idsGerentesTerritoriais.includes(gerente.id)
                    );
                this.idsGerentesTerritoriais = idsGerentesTerritoriais.map(
                    gerente => ({
                        id: gerente.id,
                        value: gerente.nome
                    })
                );
            }
            this.dados = gerente;
        },
        buscarGerentesTerritoriais() {
            return services.buscarGerentesTerritoriais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesTerritoriais = data;
                }
            });
        },
        buscarGerentesRegionais() {
            return services.buscarGerentesRegionais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesRegionais = data;
                }
            });
        },
        irParaGerentesComerciais() {
            this.$router.push({ name: 'ConfiguracaoGerentesComerciais' });
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-gerente-comercial {
    margin: 20px;

    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }

    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();

        & + & {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
